
(function (Drupal) {
  Drupal.behaviors.customButtonsBehavior = {
    attach: function (context, settings) {
      // Select the hidden select elements for both attribute unit type and attribute period.
      const unitTypeSelect = document.querySelector('select[name="purchased_entity[0][attributes][attribute_unit_type]"]');
      const periodSelect = document.querySelector('select[name="purchased_entity[0][attributes][attribute_period]"]');

      // Select the buttons associated with unit type and period.
      const unitTypeButtons = document.querySelectorAll('.btn-select-unit-type');
      const periodButtons = document.querySelectorAll('.btn-select-period');

      // Function to handle button clicks and update the select value.
      function handleButtonClick(buttons, select) {
        buttons.forEach(button => {
          button.addEventListener('click', function () {
            // Remove active class from all buttons.
            buttons.forEach(btn => btn.classList.remove('active'));

            // Add active class to the clicked button.
            button.classList.add('active');

            // Set the value of the hidden select to the clicked button's data-value.
            select.value = button.getAttribute('data-value');

            // Optionally trigger a change event if needed for other functionality.
            select.dispatchEvent(new Event('change'));
          });
        });
      }

      // Attach event listeners for unit type buttons and select.
      handleButtonClick(unitTypeButtons, unitTypeSelect);

      // Attach event listeners for period buttons and select.
      handleButtonClick(periodButtons, periodSelect);
    }
  };
})(Drupal);
